import { useEffect, useRef } from "react";

// active な間だけ Esc キーで onEscape を呼ぶ共通フック。
// 確認ダイアログ・モーダルなど「Escで閉じる」を各所で重複させないための共通化。
// onEscape は ref 経由で参照するため、インライン関数を渡しても購読を張り直さない。
export default function useEscapeKey(onEscape, active = true) {
  const ref = useRef(onEscape);
  ref.current = onEscape;
  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => { if (e.key === "Escape") ref.current(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);
}
